import { P2GBox, P2GLink, P2GText } from '@parcel2go/core-ui';
import React from 'react';

const Recaptcha: React.FC = () => {
  return (
    <P2GBox textAlign="center">
      <P2GText small>
        This site is protected by reCAPTCHA and the Google{' '}
        <P2GLink href="https://policies.google.com/privacy">Privacy Policy</P2GLink> and{' '}
        <P2GLink href="https://policies.google.com/terms">Terms of Service</P2GLink> apply.
      </P2GText>
    </P2GBox>
  );
};

export default Recaptcha;
